import React from 'react';

export type ReRenderPlacePage = {
  readonly rerender: () => void;
}

export const defaultReRenderPlacePage: ReRenderPlacePage = {
  rerender: () => { return; }
}

export const ReRenderPlacePageContext = React.createContext(defaultReRenderPlacePage);
